// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"font-awesome_iconContainer__3eQAg"};